"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const package_1 = require("../package");
const TitanShapes_1 = require("../shapes/TitanShapes");
const TemplateDropdown_1 = require("./TemplateDropdown");
// Server.call(packageName, 'loadAll', Location.shape.namedNode);
// Server.call(packageName, 'loadAll', Topic.shape.namedNode);
exports.TemplateList = (0, package_1.linkedSetComponent)(TitanShapes_1.AdSet.requestForEachInSet((template) => () => TemplateDropdown_1.TemplateDropdown.of(template)), ({ sources, getLinkedData, SelectedTemplates, isLightTheme, readonly = true, refreshList, onSelect }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: sources.map((template) => {
            var _a;
            const Dropdown = getLinkedData(template);
            // Check if the template is selected by checking if its namedNode is in SelectedTemplates
            const isSelected = (_a = SelectedTemplates === null || SelectedTemplates === void 0 ? void 0 : SelectedTemplates.some(node => node.equals(template.namedNode))) !== null && _a !== void 0 ? _a : false;
            return ((0, jsx_runtime_1.jsx)(Dropdown, { of: template, onSelect: onSelect, isLightTheme: isLightTheme, deletionCallback: refreshList, readonly: readonly, isChecked: isSelected }, template.uri));
        }) }));
});
//# sourceMappingURL=TemplateList.js.map